import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Nav from "./Nav";

const Home = () => {
  return (
    <div className="hero-section text-white">
      {/* Navbar */}
      <Nav />

      {/* Hero Content */}
      <div className="container text-center hero-content">

        <div className="badge rounded-pill bg-light text-dark mb-4 px-4 py-2 animate-badge">
          Workforce Management Experts
        </div>

        <h1 className="display-4 fw-bold animate-title">
          Transform Your <br />
          <span className="highlight">Workforce Management</span>
        </h1>

        <p className="lead mt-4 mb-5 px-lg-5 animate-subtitle">
          Expert solutions that empower your organization. From implementation
          to optimization, <br /> we deliver seamless workforce management
          transformations.
        </p>

        <div className="d-flex justify-content-center gap-3 flex-wrap animate-buttons">
          <button className="btn btn-light btn-lg px-5 fw-semibold">
            Schedule Consultation →
          </button>
          <button className="btn btn-outline-light btn-lg px-5 fw-semibold">
            Explore Services
          </button>
        </div>

        <p className="mt-5 text-light opacity-75 animate-trust">
          Trusted by enterprises across industries
        </p>

        <div className="d-flex justify-content-center gap-4 flex-wrap industries animate-industries">
          {["Healthcare", "Manufacturing", "Retail", "Finance", "Logistics"].map(
            (item, index) => (
              <span key={index}>{item}</span>
            )
          )}
        </div>
      </div>

      {/* Bottom Curve */}
      <div className="curve">
        <svg viewBox="0 0 1440 150" preserveAspectRatio="none">
          <path
            d="M0,80 C360,150 1080,0 1440,80 L1440,150 L0,150 Z"
            fill="#ffffff"
          />
        </svg>
      </div>
    </div>
  );
};

export default Home;
